export default function toText () {
	return this.fragment.toString( false );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/toText.js.map
